
import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../state';
import { postRequestSelfRegister, postRequestTokenPasswordChange } from '../../client/password';
import EmailField from '../../fields/EmailField.vue';
import TextField from '../../fields/TextField.vue';

@Component({
    components: { EmailField, ValidationObserver, TextField },
})
export default class SelfRegisterView extends Vue {
    shared = sharedState;
    local = {
        email: undefined as string | undefined,
        firstName: undefined as string | undefined,
        lastName: undefined as string | undefined,
    };

    async requestSelfRegister() {
        if (await postRequestSelfRegister(this.local.email!!, this.local.firstName!!, this.local.lastName!!)) {
            if (await postRequestTokenPasswordChange(this.local.email!!)) {
                this.$buefy.toast.open({
                    type: 'is-success',
                    message: this.$t('message.passwordChangeInstructionsSent').toString(),
                });
                this.local.email = undefined;
                await this.$router.push('/login');
            } else {
                this.$buefy.toast.open({
                    type: 'is-warning',
                    message: this.$t('message.passwordChangeInstructionsSendFailed').toString(),
                });
            }
        } else {
            this.$buefy.toast.open({
                type: 'is-warning',
                message: this.$t('message.passwordChangeInstructionsSendFailed').toString(),
            });
        }
    }

    async submit() {
        await this.requestSelfRegister();
    }

    back() {
        this.$router.go(-1);
    }
}
